import React from 'react';

interface CartLoginPromptProps {
  onLogin: () => void;
}

const CartLoginPrompt: React.FC<CartLoginPromptProps> = ({ onLogin }) => {
  return (
    <p className="text-center text-[#002B66] text-[12px] leading-[18px] font-normal font-['Noto_Sans'] mt-6">
      <a 
        onClick={onLogin} 
        className="italic underline decoration-solid underline-offset-auto cursor-pointer"
      >
        Log in
      </a>
      {' '}to save your basket and check out faster.
    </p>
  );
};

export default CartLoginPrompt;
